import { Button } from "@/components/ui/button";
import { Key } from "lucide-react";
import { useNavigate } from "react-router-dom";
import heroBg from "@/assets/bg_2.jpg";
import logo from "@/assets/logo.png";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const HeroSection = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState<{ players: number, creators: number, developers: number } | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [playersCount, creatorsCount, developersCount] = await Promise.all([
          supabase.from('profiles').select('*', { count: 'exact', head: true }).eq('user_type', 'player'),
          supabase.from('profiles').select('*', { count: 'exact', head: true }).eq('user_type', 'creator'),
          supabase.from('profiles').select('*', { count: 'exact', head: true }).eq('user_type', 'developer')
        ]);

        const total = (playersCount.count || 0) + (creatorsCount.count || 0) + (developersCount.count || 0);

        if (total >= 150) {
          setStats({
            players: playersCount.count || 0,
            creators: creatorsCount.count || 0,
            developers: developersCount.count || 0
          });
        }
      } catch (error) {
        console.error("Error fetching landing stats:", error);
      }
    };

    fetchStats();
  }, []);

  return (
    <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-background/90 via-background/80 to-background"></div>
      </div>

      <div className="container relative z-10 px-4 text-center">
        <div className="flex justify-center mb-6 gap-4">
          <div className="relative">
            <img src={logo} alt="IndieKeys" className="h-20 md:h-40 animate-pulse" />
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-center gap-1.5 mb-1 pt-2">
          <h1 className="text-md md:text-xl font-bold text-center">
            <b className="text-foreground text-2xl"><span className="gradient-text">indie</span>keys</b> — The Only Platform Connecting Indie Game Developers, Content Creators, and Players
          </h1>
        </div>

        <p className="text-sm md:text-sm text-muted-foreground max-w-xl mx-auto mb-8">
          Promote your indie games, create engaging content, and discover hidden gems
        </p>

        {stats && (
          <div className="mb-6 animate-in fade-in slide-in-from-bottom-2 duration-700 delay-500 fill-mode-both">
            <p className="text-lg font-bold flex flex-col gap-1">
              <span><span className="gradient-text font-bold text-xl">{stats.creators}</span> creators, <span className="gradient-text font-bold text-xl">{stats.developers}</span> studios and <span className="gradient-text font-bold text-xl">{stats.players}</span> players are already on <span className="gradient-text font-bold">indie</span>keys !</span>
              <span className="font-bold text-3xl">What about <span className="gradient-text">you</span>?</span>
            </p>
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            size="lg"
            className="text-lg px-8 glow-effect"
            onClick={() => navigate("/auth")}
          >
            Get Started
          </Button>
        </div>
      </div>
    </section>
  );
};
